import React, { useState } from "react";
import { HiMenuAlt3, HiX } from "react-icons/hi";

const SiteHeader = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Top Nav */}
      <header className="fixed top-0 left-0 right-0 z-50 mt-6">
        <div className="max-w-[1440px] mx-auto flex items-center justify-between px-6 py-4 rounded-3xl border border-white/20 bg-black/30 backdrop-blur-lg">
          <a href="/" className="flex items-center gap-3">
            <img
              src={encodeURI("/media/New-Images/Zenvia logo 1.webp")}
              alt="Zenvia Foods Logo"
              className="h-12 object-contain"
            />
            <span className="hidden sm:inline-block text-white font-semibold tracking-widest uppercase text-sm">Zenvia Foods</span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-12 text-white tracking-widest uppercase text-sm">
            <a href="/" className="hover:opacity-100">Home</a>
            <a href="/products" className="hover:opacity-80">Products</a>
            <a href="/applications" className="hover:opacity-80">Applications</a>
            <a href="/sustainability" className="hover:opacity-80">Sustainability</a>
            <a href="/about-us" className="hover:opacity-80">About Us</a>
            <a href="/contact-us" className="hover:opacity-80">Contact Us</a>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-2xl text-white z-50"
            aria-label="Toggle Menu"
          >
            {isOpen ? <HiX /> : <HiMenuAlt3 />}
          </button>
        </div>
      </header>

      {/* Fullscreen Overlay Menu */}
      {isOpen && (
        <div className="fixed inset-0 pt-24 bg-black/90 z-40 text-white flex flex-col items-center justify-start">
          {/* Navigation Items */}
          <nav className="flex flex-col gap-6 text-center mt-16 text-2xl font-semibold">
            <a href="/" className="hover:opacity-80">Home</a>
            <a href="/products" className="hover:opacity-80">Products</a>
            <a href="/sustainability" className="hover:opacity-80">Sustainability</a>
            <a href="/applications" className="hover:opacity-80">Applications</a>
            <a href="/about-us" className="hover:opacity-80">About Us</a>
            <a href="/contact-us" className="hover:opacity-80">Contact Us</a>
          </nav>
        </div>
      )}
    </>
  );
};

export default SiteHeader;
